import * as ReactDOM from "react-dom";
import * as SDK_Shim from "VSS/SDK/Shim";

import { WitQueryOrchestratorPageContext } from "Presentation/Scripts/TFS/Extension/WitQueryTableOrchestrator";
import { renderInto } from "Wiki/Scenarios/Shared/Components/WikiContainer";

SDK_Shim.registerContent("wiki.initialize", (context: SDK_Shim.InternalContentContextData): IDisposable => {
    WitQueryOrchestratorPageContext.setPageContext(context.options._pageContext);
    renderInto(context.container, {});

    const disposable: IDisposable = {
        dispose: (): void => {
            ReactDOM.unmountComponentAtNode(context.container);
        }
    };

    return disposable;
});
